// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productShareLinkStyles } from "@stoneage/Overrides/Components/ProductShareLink";
import { css } from "styled-components";
import { fontConfig } from "@stoneage/XDL/constants";
import IconEmail from "@stoneage/XDL/Icons/IconEmail";
import { modalButtonsActionStyles } from "@stoneage/XDL/Utilities";
import translate from "@insite/client-framework/Translate";

productShareLinkStyles.link = {
    color: "secondary",
    typographyProps: {
        ...fontConfig.xSmallSingleLine,
        weight: fontConfig.weight.medium,
    },
    icon: {
        iconProps: {
            src: IconEmail,
            size: 12,
        },
        position: "left",
    },
    css: css`
        align-self: baseline;
    `,
};

productShareLinkStyles.container = {
    gap: 20,
};

productShareLinkStyles.recipientNameGridItem = {
    width: [12, 6, 6, 6, 6],
};

productShareLinkStyles.recipientEmailGridItem = {
    width: [12, 6, 6, 6, 6],
};

productShareLinkStyles.yourNameGridItem = {
    width: [12, 6, 6, 6, 6],
};

productShareLinkStyles.yourEmailGridItem = {
    width: [12, 6, 6, 6, 6],
};

productShareLinkStyles.yourMessageGridItem = {
    width: 12,
};

productShareLinkStyles.recipientNameTextField = {
    placeholder: translate("Enter Recipient Name"),
};

productShareLinkStyles.recipientEmailTextField = {
    placeholder: translate("Enter Recipient Email"),
};

productShareLinkStyles.yourNameTextField = {
    placeholder: translate("Enter Your Name"),
};

productShareLinkStyles.yourEmailTextField = {
    placeholder: translate("Enter Your Email"),
};

productShareLinkStyles.yourMessageTextArea = {
    placeholder: translate("Enter Your Message"),
    cssOverrides: {
        inputSelect: css`
            resize: none;
        `,
    },
};

productShareLinkStyles.modal = {
    size: 600,
};

productShareLinkStyles.reCaptchaGridItem = {
    width: 12,
    css: css`
        &:empty {
            display: none;
        }
    `,
};

productShareLinkStyles.buttonsWrapper = {
    css: css`
        ${modalButtonsActionStyles.buttonsGridItem?.css}
    `,
};

productShareLinkStyles.shareButton = {
    ...modalButtonsActionStyles.submitButton,
};

productShareLinkStyles.cancelButton = {
    ...modalButtonsActionStyles.cancelButton,
};
